const ExpenseEntityIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_852_10347)">
      <path
        d="M15.25 11C15.25 12.0288 14.5807 13.0737 13.2594 13.8995C11.9486 14.7188 10.0911 15.25 8 15.25C5.90894 15.25 4.05143 14.7188 2.74065 13.8995C1.41929 13.0737 0.75 12.0288 0.75 11C0.75 9.97119 1.41929 8.92631 2.74065 8.10046C4.05143 7.28122 5.90894 6.75 8 6.75C10.0911 6.75 11.9486 7.28122 13.2594 8.10046C14.5807 8.92631 15.25 9.97119 15.25 11Z"
        stroke="black"
        stroke-width="1.5"
      />
      <path d="M8 7L5 2L11 2L8 7Z" fill="black" />
      <path d="M8 0C8 4.2019 8 2.04545 8 5" stroke="black" stroke-width="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_852_10347">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ExpenseEntityIcon;
